import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RolePermissionBO } from './roles.model';
import { catchError } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';

@Injectable()
export class RolesService {

  constructor(private httpClient: HttpClient, public errorService: ErrorService, public global: GlobalComponent) { }

  public sendGetRequest() {
    return this.httpClient.get<any[]>('/assets/roles.json').pipe(catchError(this.errorService.handleError));
  }

  public getPermissionData() {
    return this.httpClient.get<RolePermissionBO[]>('api/RolePermission/getMenudata').pipe(catchError(this.errorService.handleError));
  }

  public saveRoleData(data: any) {
    return this.httpClient.post('api/RolesAndPermission/saveSideMenuRolePermission', data).pipe(catchError(this.errorService.handleError));
  }

  public saveMenuFuncPermission(data: any) {
    return this.httpClient.post('api/RolesAndPermission/saveMenuFunctionalityRolePermission', data).pipe(catchError(this.errorService.handleError));
  }

  public newRole(data: any) {
    return this.httpClient.post('api/LoginRole/SaveLoginRole', data).pipe(catchError(this.errorService.handleError));
  }

  public SaveAllMenuRoles(data: any) {
    return this.httpClient.post('api/RolesAndPermission/SaveAllMenuRoles?isEnabled=' + data, '').pipe(catchError(this.errorService.handleError));
  }

  public SaveRoleBasedMenu(data: any) {
    return this.httpClient.post('api/RolesAndPermission/saveSideMenuRolePermission?', data).pipe(catchError(this.errorService.handleError));
  }
  
  public getheaderrole(data: URLSearchParams) {
    return this.httpClient.get<RolePermissionBO>('api/RolesAndPermission/getRolePermissions?' + data).pipe(catchError(this.errorService.handleError));
  }

  public deleteRole(roletobeDeleted: string) {
    let url = "api/LoginRole/deleteRole?";
    let param = new URLSearchParams();
    param.append("RoleId", roletobeDeleted)
    return this.httpClient.delete(url + param).pipe(catchError(this.errorService.handleError));
  }

  public SaveRoleBasedMenuNew(data: any) {
    return this.httpClient.post('api/RolesAndPermission/saveAllPermissions?', data).pipe(catchError(this.errorService.handleError));
  }

}
